import { GeolocationArea } from '../../../../domains/Geolocation/Geolocation';
import { WemapBounds } from '../types/Wemap';

export function boundsFromBoundingBox(boundingBox: GeolocationArea['boundingBox']): WemapBounds {
    const allLats = [
        boundingBox.northEast.latitude,
        boundingBox.northWest.latitude,
        boundingBox.southEast.latitude,
        boundingBox.southWest.latitude,
    ];

    const allLngs = [
        boundingBox.northEast.longitude,
        boundingBox.northWest.longitude,
        boundingBox.southEast.longitude,
        boundingBox.southWest.longitude,
    ];

    const west = Math.min(...allLngs);
    const south = Math.min(...allLats);
    const east = Math.max(...allLngs);
    const north = Math.max(...allLats);

    return [west, south, east, north] as const;
}
